<template>
  <div>
    <b-tab>
      <template #title>
        <span class="d-none d-sm-inline">Screen configuration</span>
      </template>
      <b-container>
        <div class="mb-2 d-flex justify-content-between align-items-center">
          <b-button
            variant="success"
            @click="saveScreenForm"
          >
            Save Screen configuration
          </b-button>
        </div>
        <b-form class="screenConfig">
          <b-row>
            <b-col
              v-for="(val, key, ind) in screenObj"
              :key="ind"
              md="3"
              class="p-1"
            >
              <b-form-checkbox v-model="screenObj[key].value">
                {{ screenObj[key].label }}
              </b-form-checkbox>
            </b-col>
          </b-row>
        </b-form>
      </b-container>
    </b-tab>

  </div>
</template>

<script>
import {
  BTab, BContainer, BForm, BCol, BRow, BButton, BFormCheckbox,
} from 'bootstrap-vue'
import { reactive } from '@vue/composition-api'
import { successNotification } from '@/utils/toast-notifications'

export default {
  components: {
    BTab, BContainer, BForm, BCol, BRow, BButton, BFormCheckbox,
  },
  props: {
    driverOffer: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const screenObj = reactive({
      drop_coordinates: {
        label: 'Drop  Off Location Map',
        value: false,
      },
      drop_address: {
        value: false,
        label: 'Drop Off Location',
      },
      distance_to_dropoff: {
        label: 'Trip Distance (KM)',
        value: false,
      },
      distance_to_client: {
        value: false,
        label: 'Distance To Client (KM)',
      },
      time_to_dropoff: {
        label: 'ETA To Destination (min)',
        value: false,
      },
      time_to_client: {
        label: 'ETA Driver To Pickup (min)',
        value: false,
      },
      cost_estimate: {
        label: 'Estimated Fare',
        value: false,
      },
      directions_to_dropoff: {
        value: false,
        label: 'Pathway Drawing From Pick Up To Drop Off',
      },
      client_name: {
        label: 'Customer Name',
        value: false,
      },
      client_rating: {
        value: false,
        label: 'Customer Rating',
      },
      show_payment: {
        value: false,
        label: 'Show Payment',
      },
    })
    const emitScreenObj = () => {
      const obj = {}
      Object.keys(screenObj).forEach(key => {
        obj[key] = screenObj[key].value
      })
      emit('save-screen-config', obj)
    }
    if (props.driverOffer) {
      Object.keys(props.driverOffer).forEach(key => {
        screenObj[key] = {
          ...screenObj[key],
          value: props.driverOffer[key],
        }
      })
    } else {
      emitScreenObj()
    }
    const saveScreenForm = () => {
      emitScreenObj()
      successNotification('Saved...')
    }

    return {
      screenObj,
      saveScreenForm,
    }
  },

}
</script>

<style scoped>
.screenConfig {
    border: 3px solid lightgray;
    padding: 25px;
    margin-bottom: 30px;
    border-radius: 20px;
}

</style>
